
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.2 12.25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f8bf13"}},[_c('path',{attrs:{"d":"M12.1.53c-.14.67-.27 1.34-.41 2-.02.09-.09.21-.16.27L7.81 6.13C6.55 7.26 5.29 8.39 4.02 9.52S2.67 8.17 2.67 8.17c.01-.02.04-.05.07-.07 1.77-1.98 3.54-3.95 5.31-5.93.45-.5.9-1.01 1.35-1.51.07-.08.16-.13.27-.15.81-.17 1.7-.36 2.51-.53l-.09.53z"}}),_c('path',{attrs:{"d":"M.04 10.75c-.07.11-.06.17.04.25.42.35.79.74 1.15 1.15.07.08.16.15.27.06s.13-.14 0-.3c-.04-.05-.09-.1-.13-.16.58-.61 1.21-1.17 1.88-1.69.02.02.04.05.06.06l.82.82c.08.08.15.07.23 0a.64.64 0 000-.89c-.72-.73-1.45-1.45-2.18-2.18a.63.63 0 00-.89-.01c-.09.08-.09.16 0 .24l.44.44c.14.14.29.28.43.43-.53.66-1.08 1.3-1.69 1.88l-.17-.14c-.09-.08-.19-.06-.26.05z"}})]),_c('path',{attrs:{"d":"M2.47.52c.11.02.21.07.29.16.45.5.91 1 1.35 1.51.58.65 1.17 1.3 1.75 1.95l-.15.17c-.84.93-2.27 1.01-3.21.17C1.88 3.92 1.25 3.36.63 2.8a.461.461 0 01-.15-.26C.35 1.9.2 1.14.07.48.06.42.11.36.17.36c.38.01 1.56.06 2.3.16zM9.5 8.18c-.47.45-.92.9-1.35 1.35-.02 0-.03-.02-.03-.02-.58-.53-1.18-1.07-1.77-1.6l1.62-1.43c.48.53.98 1.08 1.47 1.64l.07.07zm1.45 3.97c.35-.42.73-.8 1.15-1.15.11-.1.09-.15.01-.25s-.16-.09-.23-.04c-.06.04-.11.09-.17.14-.61-.58-1.17-1.21-1.69-1.88.15-.14.29-.29.43-.43l.44-.44c.08-.08.08-.16 0-.24a.65.65 0 00-.89.01c-.73.72-1.45 1.45-2.18 2.18a.63.63 0 000 .89c.07.08.15.08.23 0l.82-.82c.02-.02.03-.04.06-.06.67.53 1.3 1.08 1.88 1.69-.04.05-.09.1-.13.16-.06.09-.07.12.04.2s.17.12.24.04z","fill":"#ce952e"}})])
          )
        }
      }
    